export const RafModals = {
    GotCode: 'GotCode',
    CodeRefused: 'CodeRefused',
    FriendClaim: 'FriendClaim',
    OwnProgressClaim: 'OwnProgressClaim',
    CodeAccepted: 'CodeAccepted',
    StepsInfo: 'StepsInfo',
    ManualAwarding: 'ManualAwarding',
} as const;

export type RafModals = typeof RafModals[keyof typeof RafModals];

export const RafClickValues = {
    ClaimAvailable: 'claim_available',
    CopyInvitationLink: 'copy_invitation',
    CopyCodeOnly: 'copy_code_only',
    Conditions: 'conditions',
    CodeEnter: 'code_enter',
    AlreadyClaimed: 'already_claimed',
    UserTopMenu: 'user_top_menu',
    MyAccountMenu: 'my_account_menu',
    VerifySubmit: 'verify_submit',
    VerifyClaim: 'verify_claim',
    ManualAwarding: 'manual_awarding',
} as const;

export type RafClickValues = typeof RafClickValues[keyof typeof RafClickValues];
